import { CenteredCircularProgress } from '../common/CenteredCircularProgress';
import { AutomationDialogContent } from '../Automations/AutomationDialogContent';
import { AutomationFormVariant } from '../../types/enums/AutomationFormVariant';
import { useSelector } from 'react-redux';
import { selectAssignments } from '../../reducers/global/assignmentReducers';
import { selectDefaultCreationEnvironment } from '../pages/environments/environmentsReducer';
import useAutomationApiPerType from '../Automations/useAutomationApiPerType';
import { AutomationAssignmentsContextProvider } from './AutomationAssignmentsContextProvider';
import { useGetAssignmentFilters } from '../Automations/filters/helpers';
import { assignmentsSortOptions } from '../Automations/consts';
import useObjectTypesWithFetch from '../../hooks/useObjectTypesWithFetch';

export type AssignmentsProps = {
  disableCanvasTemplates?: boolean;
};

const Assignments = ({ disableCanvasTemplates }: AssignmentsProps) => {
  const assignmentRules = useSelector(selectAssignments);
  const crmOrg = useSelector(selectDefaultCreationEnvironment);
  const { onSaveOrCreate, onToggleActivation, onDeleteAutomation, onDeployAutomation } =
    useAutomationApiPerType({ automationVariant: AutomationFormVariant.ASSIGNMENT_RULES });

  const { objectTypesByName } = useObjectTypesWithFetch({ crmOrgId: crmOrg?.id ?? '' });
  const filters = useGetAssignmentFilters(assignmentRules, objectTypesByName);

  if (!assignmentRules) return <CenteredCircularProgress />;

  return (
    <>
      {crmOrg && (
        <AutomationDialogContent
          automations={assignmentRules ?? []}
          onDeleteAutomation={onDeleteAutomation}
          crmOrgId={crmOrg.id}
          onSaveOrCreate={onSaveOrCreate}
          onToggleActivation={onToggleActivation}
          sortOptions={assignmentsSortOptions}
          disableCanvasTemplates={disableCanvasTemplates}
          onDeployAutomation={onDeployAutomation}
          filters={filters}
        />
      )}
    </>
  );
};

const AssignmentsWithContext = (assignmentProps: AssignmentsProps) => {
  return (
    <AutomationAssignmentsContextProvider>
      <Assignments {...assignmentProps} />
    </AutomationAssignmentsContextProvider>
  );
};

export default AssignmentsWithContext;
